(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8573],{

/***/ 698:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/500",
      function () {
        return __webpack_require__(3897);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1083);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1156);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2213);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9521);
/* harmony import */ var _comps_cookies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1579);
/* harmony import */ var _comps_favicon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7953);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6254);
/* harmony import */ var _careers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5914);
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2673);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1816);
/* harmony import */ var _utils_googleapi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9872);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4371);
/* harmony import */ var _utils_coins__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(279);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2010);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(259);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8767);
/* harmony import */ var _sections_editor_editor__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5091);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  width: var(--w-screen);\n  padding: 25px 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n\n  min-height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--color-primary-500);\n  text-align: center;\n  max-width: 278px;\n\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 28px;\n\n  @media ",
        " {\n    font-size: 36px;\n    line-height: 44px;\n    max-width: 400px;\n  }\n\n  @media ",
        " {\n    font-size: 52px;\n    line-height: 52px;\n    max-width: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--color-blue-600);\n  text-align: center;\n  max-width: 278px;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n\n  @media ",
        " {\n    font-size: 24px;\n    line-height: 42px;\n    max-width: unset;\n  }\n\n  @media ",
        " {\n    font-size: 28px;\n    line-height: 42px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 130vw;\n  @media ",
        ' {\n    width: var(--w-screen);\n  }\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  svg {\n    path[stroke="#E0E2EB"] {\n      stroke: var(--color-blue-100);\n    }\n\n    ellipse[fill="#E0E2EB"] {\n      fill: var(--color-blue-100);\n    }\n\n    path[fill="#F5F6FC"] {\n      fill: var(--color-background);\n    }\n\n    .dark & path[fill="white"] {\n      fill: #37383f;\n    }\n  }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



















var Container = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7dfed2fa-0"
})(_templateObject());
var Icon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: "1728",
        height: "181",
        viewBox: "0 0 1728 181",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M0 93.771H377.559C399.567 93.771 417.408 75.9299 417.408 53.9216V18.0988C417.408 9.2077 424.616 2 433.507 2V2C442.398 2 449.606 9.2077 449.606 18.0988V159.721C449.606 170.369 458.238 179 468.885 179V179C479.532 179 488.164 170.369 488.164 159.721V133.62C488.164 111.612 506.005 93.771 528.013 93.771H697.202",
                stroke: "#E0E2EB",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M1728 93.771H1339.66C1317.65 93.771 1299.81 75.9299 1299.81 53.9216V18.5146C1299.81 9.39385 1292.42 2 1283.3 2V2C1274.18 2 1266.78 9.39383 1266.78 18.5146V159.223C1266.78 170.146 1257.93 179 1247.01 179V179C1236.08 179 1227.23 170.146 1227.23 159.223V133.62C1227.23 111.612 1209.39 93.771 1187.38 93.771H1010",
                stroke: "#E0E2EB",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M753.271 74.7922V116.758C753.271 122.517 750.938 127.585 747.522 130.508C744.194 133.357 739.778 134.256 735.012 131.726C722.485 125.076 715.568 109.608 715.353 94.2046C715.137 78.7873 721.618 64.4212 734.693 59.5107C740.223 57.4337 744.757 58.4099 747.925 61.1084C751.163 63.8666 753.271 68.6835 753.271 74.7922Z",
                fill: "#F5F6FC",
                stroke: "#E0E2EB",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M699.201 100.927V89.7885C699.201 76.2494 708.795 64.6088 722.085 62.0234L738.646 58.8018V132.75L720.803 128.411C708.125 125.328 699.201 113.974 699.201 100.927Z",
                fill: "white",
                stroke: "#E0E2EB",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M745.562 74.7148H772.668",
                stroke: "#E0E2EB",
                strokeWidth: "4",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M745.562 116.955H772.668",
                stroke: "#E0E2EB",
                strokeWidth: "4",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M953.931 74.7922V116.758C953.931 122.517 956.263 127.585 959.679 130.508C963.007 133.357 967.423 134.256 972.189 131.726C984.717 125.076 991.633 109.608 991.848 94.2046C992.064 78.7873 985.583 64.4212 972.508 59.5107C966.978 57.4337 962.444 58.4099 959.276 61.1084C956.038 63.8666 953.931 68.6835 953.931 74.7922Z",
                fill: "#F5F6FC",
                stroke: "#E0E2EB",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M1008 100.927V89.7885C1008 76.2494 998.406 64.6088 985.116 62.0234L968.556 58.8018V132.75L986.398 128.411C999.076 125.328 1008 113.974 1008 100.927Z",
                fill: "white",
                stroke: "#E0E2EB",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ellipse", {
                rx: "3.18888",
                ry: "3.18795",
                transform: "matrix(-1 0 0 1 960.985 76.8828)",
                fill: "#E0E2EB"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ellipse", {
                rx: "3.18888",
                ry: "3.18795",
                transform: "matrix(-1 0 0 1 960.985 118.326)",
                fill: "#E0E2EB"
            })
        ]
    });
};
var Title = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-7dfed2fa-1"
})(_templateObject1(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .devices.desktop */ .Hb.desktop);
var Subtitle = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-7dfed2fa-2"
})(_templateObject2(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .devices.desktop */ .Hb.desktop);
var Background = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7dfed2fa-3"
})(_templateObject3(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .devices.tablet */ .Hb.tablet);
var ServerError = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                children: t("common:txt_under_maintenance")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Subtitle, {
                children: [
                    t("common:txt_scheduled_maintenance_1"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    t("common:txt_scheduled_maintenance_2")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Background, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
ServerError.Layout = function Layout(props) {
    var children = props.children, theme = props.theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(next_themes__WEBPACK_IMPORTED_MODULE_15__/* .ThemeProvider */ .f, {
        attribute: "class",
        forcedTheme: theme,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_careers__WEBPACK_IMPORTED_MODULE_9__.GlobalStyle, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_query__WEBPACK_IMPORTED_MODULE_17__.QueryClientProvider, {
                client: _app__WEBPACK_IMPORTED_MODULE_10__.queryClient,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_client_auth__WEBPACK_IMPORTED_MODULE_11__/* .ClientSideAuthProvider */ .s5, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_notification__WEBPACK_IMPORTED_MODULE_13__/* .NotificationProvider */ .J, {
                        timeout: 3000,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_16__/* .GoogleReCaptchaProvider */ .pm, {
                            scriptProps: {
                                async: true
                            },
                            reCaptchaKey: "6LelseIjAAAAAEmIkD3assuAQxcbF9vd0zbE-jMG",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_coins__WEBPACK_IMPORTED_MODULE_14__/* .CoinsProvider */ ._k, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_utils_adjust__WEBPACK_IMPORTED_MODULE_8__/* .AdjustProvider */ .xF, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_favicon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_cookies__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_editor_editor__WEBPACK_IMPORTED_MODULE_18__/* .EditorParamsProviders */ .i9, {
                                            children: children
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_adjust__WEBPACK_IMPORTED_MODULE_8__/* .UsePageViewEvent */ .rs, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_googleapi__WEBPACK_IMPORTED_MODULE_12__/* .GoogleOneTap */ .K, {})
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ServerError);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5914,9774,2888,179], function() { return __webpack_exec__(698); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);